import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { OverlaySidebar } from '../internal/OverlaySidebar';
import { overlayShadowTheme } from '../../theme/default-theme';

export interface IOverlayAppProps {
    className?: string;
    hideOverlay(): void;
    isOverlayVisible: boolean;
    handleTransitionEnd?(e?: React.TransitionEvent<HTMLDivElement>): void;
    children?: React.ReactNode;
    disableScroll?: boolean;
    overlayTransition?: string;
    shadowTransition?: string;
}

export interface IOverlayShadow {
    isOverlayVisible: boolean;
    className: string;
    onClick?(val: object): void;
    transition?: string;
}

export interface IReactMouseEvent extends React.MouseEvent<HTMLDivElement> {
    target: HTMLElement & EventTarget;
}

const StyledOverlayShadow = styled.div<IOverlayShadow & React.HTMLProps<HTMLDivElement>>`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: ${({ transition }) =>
        `visibility ${transition || '1s'}, opacity ${transition || '1s'} linear`};
    opacity: ${props => (props.isOverlayVisible ? '1' : '0')};
    visibility: ${props => (props.isOverlayVisible ? 'visible' : 'hidden')};
    z-index: 999;
    ${overlayShadowTheme}
`;

@observer
export class Overlay extends React.Component<IOverlayAppProps> {
    constructor(props: IOverlayAppProps) {
        super(props);
    }

    componentDidMount = () => {
        document.addEventListener('keydown', this.handleEscPress);
    };

    componentWillUnmount = () => {
        document.removeEventListener('keydown', this.handleEscPress);
    };

    componentDidUpdate = () => {
        if (this.props.disableScroll) {
            this.handleScroll();
        }
    };

    private handleShadowClick = (event: IReactMouseEvent): void => {
        if (event.target.classList.contains('js-overlay-shadow')) {
            this.props.hideOverlay();
        }
    };

    private handleEscPress = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            this.props.hideOverlay();
        }
    };

    private handleScroll = () => {
        const { body } = document;
        const [root] = document.getElementsByTagName('html');

        root.style.height = this.props.isOverlayVisible ? 'auto' : '';
        root.style.overflowY = this.props.isOverlayVisible ? 'hidden' : '';

        body.style.height = this.props.isOverlayVisible ? '100%' : '';
        body.style.overflowY = this.props.isOverlayVisible ? 'hidden' : '';
    };

    public render() {
        const overlayShadowClass = classnames(
            'elc-overlay-shadow',
            'js-overlay-shadow',
            this.props.isOverlayVisible
                ? ['elc-overlay-shadow-visible', 'js-overlay-shadow-visible']
                : ''
        );

        return (
            <div onTransitionEnd={this.props.handleTransitionEnd}>
                <StyledOverlayShadow
                    className={overlayShadowClass}
                    onClick={this.handleShadowClick}
                    isOverlayVisible={this.props.isOverlayVisible}
                    transition={this.props.shadowTransition}
                />
                <OverlaySidebar
                    isOverlayVisible={this.props.isOverlayVisible}
                    transition={this.props.overlayTransition}
                >
                    {this.props.children}
                </OverlaySidebar>
            </div>
        );
    }
}
